export const HousePageTabs = {
  ExteriorPhotos: 'ExteriorPhotos',
  RoomsPhotos: 'RoomsPhotos',
  Virtual3DTour: 'Virtual3DTour',
  StreetView: 'StreetView',
  Map: 'Map',
  GuidedTour: 'GuidedTour',
} as const;

export const HOUSE_PAGE_TABS = {
  FEATURED: {
    text: 'Photos',
    key: 'photos',
    mediaName: HousePageTabs.ExteriorPhotos,
  },
  PHOTOS: {
    text: 'Rooms',
    key: 'rooms',
    mediaName: HousePageTabs.RoomsPhotos,
  },
  MAP: {
    text: 'Map',
    key: 'map',
    mediaName: HousePageTabs.Map,
  },
  WALK_AROUND: {
    text: '3D Tour',
    key: '3D-tour',
    mediaName: HousePageTabs.Virtual3DTour,
  },
  STREET_VIEW: {
    text: 'Street View',
    key: 'street',
    mediaName: HousePageTabs.StreetView,
  },
  GUIDED_TOUR: {
    text: 'Virtual Tour',
    key: 'virtual-tour',
    mediaName: HousePageTabs.GuidedTour,
  },
};

export const ALLOWED_TABS_WHEN_LOVE: string[] = [
  HOUSE_PAGE_TABS.FEATURED.mediaName,
  HOUSE_PAGE_TABS.MAP.mediaName,
  HOUSE_PAGE_TABS.STREET_VIEW.mediaName,
];
